import apiFetch from '../apiFetch'

export default function (token, templateId) {
  return apiFetch({ endPoint: `template/${templateId}`, method: 'GET', body: null, token: token })
}
